export default __webpack_public_path__ + "images/api_key_v2_intro_1-Hq0rh.png";